import { cn } from '@/common/utilities.ts'

const LoaderVariants = {
  size: {
    sm: 'w-1 h-1',
    md: 'w-2 h-2',
    lg: 'w-3 h-3',
  },
  color: {
    black: 'bg-black',
    dark_gray: 'bg-gray-600',
    gray: 'bg-gray-500',
    light_gray: 'bg-gray-400',
    primary: 'bg-primary',
  },
}

export type EllipsesLoaderProps = {
  size: keyof typeof LoaderVariants.size
  color?: keyof typeof LoaderVariants.color
}

export const EllipsesLoader = ({
  size = 'md',
  color = 'primary',
}: EllipsesLoaderProps) => {
  return (
    <div className="flex gap-2">
      {Array(3)
        .fill(0)
        .map((_, index) => {
          return (
            <div
              className={cn(
                LoaderVariants.size[size],
                LoaderVariants.color[color],
                'rounded-full animate-jump',
                index == 0 && 'animate-jump',
                index != 0 && `animate-delay-${index}00`
              )}
              key={index}
            ></div>
          )
        })}
    </div>
  )
}
